@let currentLanguage = currentLanguage$ | async;

<div class="ecl-container">
    <h1 class="ecl-u-type-heading1 ecl-u-mt-l ecl-u-border-bottom ecl-u-border-color-primary-40 ecl-u-pb-s ecl-u-type-bold">
        {{'easeportal.breadcrumb.ACCESS-DENIED' | translate }}
    </h1>

    <p class="ecl-u-mt-m ecl-u-type-paragraph">{{'easeportal.forbidden.DESCRIPTION' | translate}}</p>

    <div class="ecl-u-mt-m">
        <button eclButton variant="secondary"
                routerLink="/home"
                class="ecl-u-mt-2xl ecl-u-mb-m">
            {{ 'easeportal.forbidden.RETURN-HOME' | translate}}
        </button>
    </div>
    <div class="ecl-u-mt-m">
        <a eclLink variant="secondary"
           href="https://ec.europa.eu/info/index_{{currentLanguage}}" >
            {{ 'easeportal.forbidden.RETURN-EUROPIAN-COMMISSION' | translate}}
        </a>
    </div>
</div>

